export const skillsData2 = [
  {
    name: "HTML",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875562/portfolio/skills/html.png",
  },
  {
    name: "CSS",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875562/portfolio/skills/css.png",
  },
  {
    name: "JavaScript",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875561/portfolio/skills/js.png",
  },
  {
    name: "TypeScript",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875562/portfolio/skills/ts.png",
  },
  {
    name: "React",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875562/portfolio/skills/reactjs.png",
  },
  {
    name: "Next.js",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875561/portfolio/skills/nextjs.png",
  },
  {
    name: "Tailwind",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875562/portfolio/skills/tellwand.png",
  },
  {
    name: "Redux",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875561/portfolio/skills/redux.png",
  },
  {
    name: "React Query",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875562/portfolio/skills/reactquary.png",
  },
  {
    name: "Git",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875561/portfolio/skills/git.png",
  },
  {
    name: "Figma",
    image:
      "https://res.cloudinary.com/dyv3dluov/image/upload/v1731875560/portfolio/skills/figma.png",
  },
];

export const skillGroups = [
  {
    title: "Frontend",
    items: [
      "React.js",
      "Next.js",
      "TypeScript",
      "JavaScript (ES6+)",
      "HTML5",
      "CSS3",
    ],
  },
  {
    title: "Styling & UI",
    items: ["Tailwind CSS", "Shadcn UI", "MUI", "Bootstrap", "Styled Components"],
  },
  {
    title: "State & Data",
    items: ["Redux Toolkit", "React Query", "Context API", "Axios", "GraphQL"],
  },
  {
    title: "Backend & APIs",
    items: ["ASP.NET Core", "REST APIs", "C# (basic)", "Error Handling"],
  },
  {
    title: "Tooling",
    items: ["Git", "GitHub", "Vite", "VS Code", "Figma", "Chrome DevTools"],
  },
  {
    title: "Delivery",
    items: [
      "Lighthouse",
      "Lazy loading",
      "Code-splitting",
      "next-intl",
      "Agile / Scrum",
      "Jira",
    ],
  },
];
